import React from 'react';

import styles from '../../styles/entity-scores-widget.module.scss';
import {observer} from 'mobx-react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {EntityScoresWidgetSectionTitle} from "./entity-scores-widget.section.title";
import {EntityScoresWidgetSectionFooter} from "./entity-scores-widget.section.footer";
import classNames from "classnames";
import {EntityScoresWidgetGroups} from "../groups/entity-scores-widget.groups";
import {IntersectionObserver} from "../../../../core/components/intersection-observer/intersection-observer";

export class EntityScoresWidgetSectionProps extends BaseProps {
}

export const EntityScoresWidgetSection = observer(({
                                                     controller,
                                                     section,
                                                     onFilterChange,
                                                     isSideBar
                                                   }: EntityScoresWidgetSectionProps) => {
  const {liveGroupsArray, shouldRenderLiveGroups, notLiveGroupsArray, showFooter} = section;

  const gamesList = {
    shouldRenderTitle: shouldRenderLiveGroups,
    controller,
    isSideBar
  };

  const liveGamesProps = {
    items: liveGroupsArray,
    isLive: true,
    ...gamesList
  }

  const gamesProps = {
    items: notLiveGroupsArray,
    ...gamesList
  }

  const footerProps = {
    controller,
    section,
    onSeeAllClick: onFilterChange
  }

  const sectionTitleProps = {
    controller,
    section,
  }

  return (
    <IntersectionObserver className={classNames(styles.section_container)}>
      <EntityScoresWidgetSectionTitle {...sectionTitleProps}/>
      {
        liveGroupsArray?.length > 0 ? <EntityScoresWidgetGroups {...liveGamesProps}/> : null
      }
      {
        notLiveGroupsArray?.length > 0 ? <EntityScoresWidgetGroups {...gamesProps}/> : null
      }
      {
        showFooter ? <EntityScoresWidgetSectionFooter {...footerProps}/> : null
      }
    </IntersectionObserver>
  );
});
